/* eslint-disable */
import createIcon from '../createIcon';

const IconCaretRightOutlined = createIcon({
  name: 'icon-caret-right-outlined',
  content: '<title>树/展开箭头</title><g stroke-width="1" fill="none" fill-rule="evenodd"><polygon fill="currentColor" points="349.5 255.5 349.5 767.5 674.5 511.5"/></g>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconCaretRightOutlined;
